import React, { Component } from 'react';
import '../../css/lampDetails.css'
import Program from '../../components/streetLight/Program/Program';

var api = require("../../../utils/api-v2");


class SectionDetails extends Component {
	constructor(props) {
		super(props);
		this.state = { editing: false, name: props.section.name, time: "00:00", value: "ON" }
	}
	render() {
		const { editing } = this.state

		return (
			<div>
				{editing ? this.renderEdit() : this.renderNormal()}
			</div>
		);
	}

	renderNormal() {

		const { section, onRefreshInfo } = this.props

		return (
			<div>
				<Program item={section} isSection={true} onRefreshInfo={onRefreshInfo} />

				<div className="d-flex justify-content-around my-3">
					<button className='btn btn-secondary' onClick={() => { this.setState({ editing: true }) }}>
						Editar Grupo
					</button>
				</div>
			</div>
		)
	}

	renderEdit() {
		const { section, onClose } = this.props
		const { name, } = this.state

		let doneClicked = () => {
			api.updateSection(section._id, { name: name })
			this.setState({ editing: false });
		}
		let deleteClicked = () => {
			if (section.children.length > 0 || section.groups.length > 0) {
				window.alert("La sección debe estar vacía para poder ser eliminada")

			} else if (window.confirm("Eliminar Seccion " + name + "?")) {
				api.deleteSection(section._id);
				onClose();
			}
		}

		return (
			<div className='detail-edit-form'>
				<div className="d-flex justify-content-between my-2">
					<div >Nombre</div>
					<div ><input type="text" onChange={(e) => { this.setState({ name: e.target.value }) }} value={name} /></div>
				</div>

				<div className="detail-edit-buttons">
					<button className="btn btn-secondary" onClick={doneClicked}>OK</button>
					<button className="btn btn-danger" onClick={deleteClicked}>Eliminar</button>
				</div>


			</div>


		)
	}
}

export default SectionDetails;